import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DLPRestUtilityService } from '../services/rest/dlprest-utility.service';
import { LoginRenderingService } from '../services/login/login-rendering.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationLabelEN } from '../models/labels/notificationLabel_EN';


@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  label: NotificationLabelEN;
  constructor(private router: Router,
    private dlprestService: DLPRestUtilityService, private loginRenderingService: LoginRenderingService) { }

  ngOnInit() {
    this.label = new NotificationLabelEN();
  }
  routeto() {
    this.router.navigate(['/preapprovals']);
  }
}
